export const formatBlockIndex = (index: number): string => `${leadingZeros(index)}.`;
